export const ACTION_TYPES = {
  SET_SUBSCRIPTION: 'subscription/SET_SUBSCRIPTION',
  SET_INITIALIZE_SUBSCRIPTION: 'subscription/SET_INITIALIZE_SUBSCRIPTION',
  SET_SHORT_OFFER_CODE: 'subscription/SET_SHORT_OFFER_CODE',
  CREATE_PENDING_SUBSCRIPTION: 'subscription/CREATE_PENDING_SUBSCRIPTION',
  INIT_CREATE_PENDING_SUBSCRIPTION: 'subscription/INIT_CREATE_PENDING_SUBSCRIPTION',
  RESET_CREATE_PENDING_SUBSCRIPTION: 'subscription/RESET_CREATE_PENDING_SUBSCRIPTION',
  SET_SOURCE: 'subscription/SET_SOURCE',
  SET_DOCUMENTS_SIGNED: 'subscription/SET_DOCUMENTS_SIGNED',
  SET_ERROR: 'subscription/SET_ERROR',
  SET_SIGN_ERROR: 'subscription/SET_SIGN_ERROR',
  RESET_ERROR: 'subscription/RESET_ERROR',
  RESET_SIGN_ERROR: 'subscription/RESET_ERROR'
};
